import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { NextLinkComposed } from './Link';


const Paginator = ({pageDown, previousUrl, currentPage, totalPages, pageUp, nextUrl}) => {

  return (
    <Box display="flex" justifyContent="space-between" my={2} alignItems="center">
      {pageDown ?
        <Button
          variant="contained"
          color="primary"
          component={NextLinkComposed}
          to={previousUrl}
        >Previous</Button> :
        <Box component="span" sx={{ width: 90 }} />
      }
      <Typography>{currentPage} of {totalPages}</Typography>
      {pageUp <= totalPages ?
        <Button
          variant="contained"
          color="primary"
          component={NextLinkComposed}
          to={nextUrl}
          sx={{ width: 90 }}
        >Next</Button> :
        <Box component="span" sx={{ width: 90 }} />
      }
    </Box>
  )
}

export default Paginator;
